import { formatAsDay } from '~/utils/time'
import { generateCalendarDates } from '~/components/Calendar/helpers'

export default function CalendarDates({
  onDateClick,
  selectedDate,
  sessionDays,
}: {
  onDateClick: (date: Date) => void
  selectedDate: Date
  sessionDays?: string[]
}): React.ReactElement {
  return (
    <div className="grid grid-cols-7 gap-1 2xl:gap-2">
      {generateCalendarDates(selectedDate).map((date) => {
        if (date > new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 0))) {
          const day = formatAsDay(date)
          const hasSession = sessionDays?.some((sessionDay) => sessionDay === day)
          const isActiveDate = selectedDate.getDate() === date.getDate()

          return (
            <button
              className={
                'relative w-10 h-10 flex items-center justify-center font-semibold select-none text-xxs ' +
                `${isActiveDate ? 'bg-purple-light rounded-full focus:outline-none' : ''}`
              }
              key={date.valueOf()}
              onClick={() => onDateClick(date)}
            >
              {date.getDate()}
              {hasSession && <span className="absolute mt-5 block w-1 h-1 rounded-full bg-purple" />}
            </button>
          )
        } else {
          return <span key={date.valueOf()} />
        }
      })}
    </div>
  )
}
